import React, { useMemo } from 'react';
import styles from './logo.module.scss.js';
import { ShoppingLogo } from '../ShoppingLogo.js';
import { ShoppingLogoMobileMini } from '../ShoppingLogoMobileMini.js';

/* eslint-disable camelcase */
function Logo(_ref) {
  let {
    tracking,
    pageType,
    useUnitTracking,
    baseUrl,
    baseParamsString,
    isShowPrimeDay
  } = _ref;
  const href = `${baseUrl}/${baseParamsString ? '?' + baseParamsString : ''}`; // add edition and ?s=shopping_plus to link

  const title = 'BuzzFeed Shopping logo';
  const itemTrackingLayer = useMemo(() => ({
    ...tracking,
    subunit_type: '',
    subunit_name: '',
    item_type: 'image',
    item_name: 'logo',
    target_content_type: 'url',
    target_content_id: href,
    target_content_url: href
  }), [tracking, href]);
  const ref = useUnitTracking(itemTrackingLayer);
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: `${styles.heading} ${pageType !== 'default' ? styles.headingMini : styles.headingDefault}`
  }, /*#__PURE__*/React.createElement("a", {
    href: href,
    className: `${isShowPrimeDay ? styles.logoWrapper : ''}`
  }, pageType !== 'default' && /*#__PURE__*/React.createElement(ShoppingLogoMobileMini, {
    className: styles.logoMini,
    title: title
  }), /*#__PURE__*/React.createElement(ShoppingLogo, {
    className: styles.logo,
    title: title
  })), isShowPrimeDay && /*#__PURE__*/React.createElement("div", {
    className: styles.primeDayLogo
  }, /*#__PURE__*/React.createElement("img", {
    src: "https://img.buzzfeed.com/store-an-image-prod-us-east-1/NSjL02fe2.gif",
    alt: "Prime Day"
  })));
}

export { Logo, Logo as default };
